import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppState } from '../app.service';
import { map } from 'rxjs/operators';
import { LoginSharedService } from '../login/login-shared.service';
import { NotificationService } from '../shared/generic-notification/notification.service';
import { SharingServices } from '../cms-editor/services/sharing-service';
import { BlobStorageService } from '../cms-editor/services/api-services/cms-blob.service';
import { FeatureChecker } from '../shared/feature-checker.service';

@Injectable({ providedIn: 'root' })
export class RouteProtectionGuard  {

    constructor(private readonly appService: AppState,
        private readonly loginSharedService: LoginSharedService,
        private readonly notificationService: NotificationService,
        private readonly blobservice: BlobStorageService,
        private readonly sharing: SharingServices,
        private readonly featureChecker: FeatureChecker) { }

    public async canActivateChild(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        if ((this.loginSharedService.userAttributes.length > 0)
            || state.url.startsWith('/saml') || state.url.startsWith('/integration')) {
            return Promise.resolve(true);
        }
        this.notificationService.loadingEvent.next({ showLoading: true, loadingMessage: 'Loading App..!' });

        try {
            await this.appService.getInitialToken()
                .pipe(
                    map(res => {
                        this.appService.publishSessionChange(res);
                        return true;
                    })
                ).toPromise();

            this.blobservice.menu('/iac').subscribe({
                next: (res_2) => {
                    if (res_2) {
                        this.sharing.publishToken.next(res_2);
                    }
                },
                error: () => { return state.url === '/' || state.url === '/home'; }
            });

            this.featureChecker.refreshSiteFeatures();

            this.notificationService.loadingEvent.next({ showLoading: false });
            return true;
        } catch (_) {
            this.notificationService.loadingEvent.next({ showLoading: true, loadingMessage: 'Error Initiating App..!' });
            return state.url === '/' || state.url === '/home';
        }
    }
}
